module.exports = __webpack_public_path__ + "media/photo/AdobeStock_300874234_Update_Wider@2x-112479bb.jpg";